import React, { useEffect, useState } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const ScrollColorTransition = () => {
    const [overlay] = useState(() => {
        const div = document.createElement('div');
        div.style.position = 'fixed';
        div.style.top = '0';
        div.style.left = '0';
        div.style.width = '100%';
        div.style.height = '100%';
        div.style.backgroundColor = '#000000';
        div.style.pointerEvents = 'none';
        div.style.zIndex = '-1';
        div.id = 'color-overlay';
        return div;
    });

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        document.body.appendChild(overlay);
        document.body.style.color = '#ffffff';

        const scrollTrigger = {
            trigger: "#color-transition-container",
            start: "top top",
            end: "bottom bottom",
            scrub: 1,
            onUpdate: (self) => {
                const progress = self.progress;
                const textColor = progress > 0.5 ? '#000000' : '#ffffff';
                document.body.style.color = textColor;
            }
        };

        gsap.to(overlay, {
            backgroundColor: '#ffffff',
            ease: 'none',
            scrollTrigger
        });

        document.body.style.transition = 'color 0.3s ease';

        return () => {
            overlay.remove();
            document.body.style.color = '';
            document.body.style.transition = '';
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, [overlay]);

    return (
        <div
            id="color-transition-container"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '200vh',
                pointerEvents: 'none',
                zIndex: -1
            }}
        />
    );
};

export default ScrollColorTransition;
